export default __webpack_public_path__ + "static/media/systemModuleImage.93d5818b.svg";